import { classNames, React } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { TypeControlBtn } from './TypeControlBtn';
import { styles } from './TypeControl.scss';

const cx = classNames.bind(styles);

export const TypeControl = ({ current, isStreetViewAvailable, onClick }) => (
  <div className={cx('c-map-type-control')}>
    <div className="c-map-type-control__inner">
      <TypeControlBtn
        active={current === 'ROADMAP'}
        onClick={() => onClick('ROADMAP')}>
        2d Map
      </TypeControlBtn>
      <TypeControlBtn
        active={current === 'HYBRID'}
        onClick={() => onClick('HYBRID')}>
        Satellite
      </TypeControlBtn>
      <TypeControlBtn
        disabled={!isStreetViewAvailable}
        active={current === 'STREET'}
        onClick={() => onClick('STREET')}>
        Street View
      </TypeControlBtn>
    </div>
  </div>
);

TypeControl.propTypes = {
  current: PropTypes.string,
  isStreetViewAvailable: PropTypes.bool,
  onClick: PropTypes.func,
};
